// @mui
import { useTheme } from '@mui/material/styles';
import { Box, CardHeader, Stack, Typography } from '@mui/material';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// components
import Carousel, { CarouselArrows, useCarousel } from 'src/components/carousel';

// ----------------------------------------------------------------------
const paymentMethodIcons = [
  '/assets/images/home/payments/bank-transfer.svg',
  '/assets/images/home/payments/mastercard.svg',
  '/assets/images/home/payments/visa.svg',
  '/assets/images/home/payments/noda-identity-verification.svg',
  '/assets/images/home/payments/rapid.svg',
  '/assets/images/home/payments/skrill.svg',
  '/assets/images/home/payments/astropay.svg',
  '/assets/images/home/payments/jeton.svg',
  '/assets/images/home/payments/paysafecard.svg',
  '/assets/images/home/payments/neosurf.svg',
  '/assets/images/home/payments/interac-signup.svg',
  '/assets/images/home/payments/neteller.svg',
  '/assets/images/home/payments/pay-via-bank.svg',
  '/assets/images/home/payments/paydo.svg',
  '/assets/images/home/payments/mifinity.svg',
  '/assets/images/home/payments/ezee.svg',
  '/assets/images/home/payments/luxon.svg',
  '/assets/images/home/payments/epaycore-advcash.svg',
  '/assets/images/home/payments/tether-trc.svg',
  '/assets/images/home/payments/tether-erc.svg',
  '/assets/images/home/payments/bitcoin.svg',
  '/assets/images/home/payments/ethereum.svg',
  '/assets/images/home/payments/litecoin.svg',
  '/assets/images/home/payments/dai.svg',
  '/assets/images/home/payments/dogecoin.svg',
  '/assets/images/home/payments/usd-coin.svg',
  '/assets/images/home/payments/bitcoin-cash.svg',
  '/assets/images/home/payments/tron.svg',
  '/assets/images/home/payments/ripple.svg',
  '/assets/images/home/payments/cardano.svg',
  '/assets/images/home/payments/bnb.svg',
  '/assets/images/home/payments/cash-2-code.svg',
  '/assets/images/home/payments/ecopayz.svg',
  '/assets/images/home/payments/caja-rural.svg',
  '/assets/images/home/payments/oxxo.svg',
  '/assets/images/home/payments/',
];

const PaymentMethodsView = () => {
  const theme = useTheme();
  const isMobile = useResponsive('down', 'sm');

  const carousel = useCarousel({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 6,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: theme.breakpoints.values.lg,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: theme.breakpoints.values.md,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: theme.breakpoints.values.sm,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });

  return (
    <Box mt={2}>
      {/* {isMobile ? (
        <Typography variant="body1" fontWeight={700} color="#fff">
          Payment Methods
        </Typography>
      ) : (
        <CardHeader
          title="Payment Methods"
          subheader="It's easy, fast and safe!"
          action={<CarouselArrows onNext={carousel.onNext} onPrev={carousel.onPrev} />}
          sx={{
            p: 0,
            mb: 2,
            color: '#fff',
          }}
        />
      )} */}

      <Carousel ref={carousel.carouselRef} {...carousel.carouselSettings}>
        {paymentMethodIcons.map((url) => (
          <Stack
            key={url}
            justifyContent="center"
            alignItems="center"
            sx={{
              px: { xs: 0.25, md: 1 },
              py: 1,
              height: 88,
              transition: 'all .15s ease-in-out',
              cursor: 'pointer',
              '&: hover': {
                width: 1,
                p: 0,
              },
            }}
          >
            <Stack
              justifyContent="center"
              alignItems="center"
              py={2.5}
              sx={{ height: 1, background: 'white', borderRadius: 2 }}
            >
              <Box
                component="img"
                src={url}
                height={32}
                maxWidth="calc(100% - 1rem)"
                sx={{
                  animation: 'fadeIn .3s ease',
                  backgroundSize: '100% 100%',
                }}
              />
            </Stack>
          </Stack>
        ))}
      </Carousel>
    </Box>
  );
};

export default PaymentMethodsView;
